module.exports = __webpack_public_path__ + "static/media/aw-whistledog-mb-fr.de74803f.jpg";